import { SHOW_APP_LOADING, SHOW_APP_MESSAGE, SHOW_APP_DIALOG_NOTIFY } from './actionTypes';

export const actionShowAppLoading = (payload) => ({ type: SHOW_APP_LOADING, payload });
export const actionShowAppMessage = (payload) => ({ type: SHOW_APP_MESSAGE, payload });
export const actionShowAppDialogNotify = (payload) => ({ type: SHOW_APP_DIALOG_NOTIFY, payload });

